import { ProfileV2 } from '@/models/profile';

export const LS_PROFILE = 'ARISE_PROFILE';

export function storeProfileV2InLocalStorage(profile: ProfileV2) {
    try {
        localStorage.setItem(LS_PROFILE, JSON.stringify(profile));
    } catch (error) {
        console.error('storeProfileV2InLocalStorage error: Could not store local profile', error);
    }
}

export function getProfileV2FromLocalStorage(): ProfileV2 | undefined {
    try {
        const storedProfile = localStorage.getItem(LS_PROFILE);
        if (!storedProfile) return undefined;

        const parsed = JSON.parse(storedProfile);

        // Validate essential structure to ensure it's a real ProfileV2
        if (
            parsed &&
            typeof parsed === 'object' &&
            Array.isArray(parsed.titles) &&
            Array.isArray(parsed.badges) &&
            typeof parsed.displayName === 'string'
        ) {
            return parsed as ProfileV2;
        }

        console.warn('getProfileV2FromLocalStorage: Invalid profile format in storage');
        return undefined;
    } catch (error) {
        console.error('getProfileV2FromLocalStorage error: Could not parse local profile', error);
        return undefined;
    }
}

export function clearProfileV2FromLocalStorage() {
    try {
        localStorage.removeItem(LS_PROFILE);
    } catch (error) {
        console.error('clearProfileV2FromLocalStorage error: Could not clear local profile', error);
    }
}
